/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface ResetPasswordRequest {
  accountId?: string;
  email?: string;
  otp: string;
  password: string;
  loginId?: string;
  product?: string;
}

export interface ResetPasswordRequestToApiResponse {
  account_id?: string;
  email?: string;
  otp: string;
  password: string;
  login_id?: string;
  product?: string;
}

export const resetPasswordRequestToApiRequest = (
  request: ResetPasswordRequest
): ResetPasswordRequestToApiResponse => {
  return {
    email: request.email,
    otp: request.otp,
    password: request.password,
    ...(request.accountId && {account_id: request.accountId}),
    ...(request.email && {email: request.email}),
    ...(request.loginId && {login_id: request.loginId}),
    ...(request.product && {product: request.product}),
  };
};

// Send Reset Password Email Requet

export interface EmailResetPasswordRequest {
  accountId?: string;
  email?: string;
  loginId?: string;
  product?: string;
}

export interface EmailResetPasswordRequestToApiResponse {
  account_id?: string;
  email?: string;
  login_id?: string;
  product?: string;
}

export const emailResetPasswordRequestToApiResponse = (
  request: EmailResetPasswordRequest
): EmailResetPasswordRequestToApiResponse => {
  return {
    ...(request.email && {email: request.email}),
    ...(request.accountId && {account_id: request.accountId}),
    ...(request.loginId && {login_id: request.loginId}),
    ...(request.product && {product: request.product}),
  };
};

// Send Forgot Login ID

export interface ForgotLoginId {
  accountNameId: string;
  email: string;
}

export interface ForgotLoginIdApiRequest {
  account_name_id: string;
  email: string;
}

export const forgotLoginIdToApiRequest = (request: ForgotLoginId): ForgotLoginIdApiRequest => {
  return {
    email: request.email,
    account_name_id: request.accountNameId,
  };
};
